/**
 * CI-21979 — Configuración del header numberOfDecimalsBE.
 *
 * Identifica, de forma centralizada y por (método HTTP + ruta normalizada), las
 * operaciones EXACTAS en alcance para enviar la cantidad de decimales al backend.
 *
 * En alcance (BFF de ancillaries, {urlApiAncillariesBFF}{versionAncillariesBFF}/kiosk/ancillaries):
 *   - POST .../kiosk/ancillaries/ancillaries-offer-baggage  (antes /ac/ancillaries/v2)
 *   - POST .../kiosk/ancillaries/seatmap-offer-seats        (antes /ac/seatmap/v2)
 *   - POST .../kiosk/ancillaries/seat-seating               (antes /ac/seat/v3)
 *
 * En alcance (micro, no entra al BFF):
 *   - PUT  /ac/ancillaries/v2/{pnr}   (exactamente un segmento de PNR)
 *
 * Tolera URL absoluta, query params y slash final. La comparación no depende del
 * dominio del ambiente ni de la ruta base (p. ej. /host/api) y evita falsos positivos
 * (no se amplía a subrutas no autorizadas ni a otros métodos sobre la misma URL).
 */

import { normalizePath } from '@app/utils/functions/normalize-path';

/** Nombre del header HTTP enviado al backend. */
export const NUMBER_OF_DECIMALS_HEADER = 'numberOfDecimalsBE';

/** Rutas (sin host/query/slash final) habilitadas para POST; ancladas al final. */
const POST_PATHS_IN_SCOPE = [
  /\/v\d+\/kiosk\/ancillaries\/ancillaries-offer-baggage$/,
  /\/v\d+\/kiosk\/ancillaries\/seatmap-offer-seats$/,
  /\/v\d+\/kiosk\/ancillaries\/seat-seating$/,
];

/** PUT solo sobre /ac/ancillaries/v2/{pnr} (micro): exactamente un segmento de PNR. */
const PUT_ANCILLARIES_PNR_PATH = /^\/ac\/ancillaries\/v2\/[^/]+$/;

/**
 * Indica si la operación (método + URL) está en alcance para el header
 * numberOfDecimalsBE.
 *
 * @param method método HTTP del request.
 * @param url URL del request (absoluta o relativa).
 */
export function isNumberOfDecimalsHeaderInScope(method: string, url: string): boolean {
  const httpMethod = (method || '').toUpperCase();
  const path = normalizePath(url);

  if (httpMethod === 'POST') {
    return POST_PATHS_IN_SCOPE.some((scope) => scope.test(path));
  }

  if (httpMethod === 'PUT') {
    return PUT_ANCILLARIES_PNR_PATH.test(path);
  }

  return false;
}
